import { useBreakpointUp } from '@provider-portal/design-common/clay/hooks/useBreakpoint';

/**
 * The NavBar renders as a permanent left sidebar from the `md` breakpoint (1140px) upwards;
 * below it, the NavBarDrawer switches to a temporary drawer.
 *
 * The app-shell content wrapper reads the same breakpoint through this hook so its left margin
 * stays in lockstep with the sidebar.
 */
export function useHasPermanentNavBar(): boolean {
  return useBreakpointUp('md');
}
